import React from 'react'

import FeedbackForm, { FeedbackFormValues } from '@/app/module/user/component/feedback-form'
import { useSendFeedback } from '@/app/module/user/hooks/use-send-feedback'

type Props = {}

const InlineFeedbackForm: React.FC<Props> = () => {
  const [shouldReset, setShouldReset] = React.useState(false)
  const [sendFeedback, { isLoading: isSending }] = useSendFeedback()

  React.useEffect(() => {
    if (!shouldReset) {
      return
    }
    // we need to set shouldReset back to false when it's true so it can trigger form reset the 2nd time
    // this wasn't a problem with the dialog because we don't always render the form
    setShouldReset(false)
  }, [shouldReset])

  const handleSubmit = async (data: FeedbackFormValues) => {
    const success = await sendFeedback({
      message: data.message.trim(),
    })

    if (success) {
      setShouldReset(true)
    }
  }

  return (
    <FeedbackForm
      autoFocus={false}
      hideTitle
      isSubmitting={isSending}
      shouldReset={shouldReset}
      onSubmit={handleSubmit}
    />
  )
}

export default InlineFeedbackForm
